<script>
import { api } from "@/state/services";
import { formatPoints } from "@/state/helpers/experiences";

// Experiências: quantas podem ser resgatadas e até 3 em destaque
export default {
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
    };
  },
  computed: {
    redeemable() {
      return this.list.filter((item) => item.canRedeem).length;
    },
    // Destaques (featured); sem destaques, as 3 primeiras
    highlights() {
      const featured = this.list.filter((item) => item.featured);
      return (featured.length > 0 ? featured : this.list).slice(0, 3);
    },
  },
  methods: {
    formatPoints,
  },
  mounted() {
    api
      .get("experiences")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          this.list = response.data.list || [];
        } else {
          this.errored = true;
        }
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<template>
  <div v-if="!errored" class="card">
    <div class="card-body p-3">
      <div v-if="loading">
        <b-skeleton width="70%" class="mb-3"></b-skeleton>
        <div class="row">
          <div v-for="n in 3" :key="n" class="col-12 col-md-4 mb-2"><b-skeleton-img aspect="16:9"></b-skeleton-img></div>
        </div>
      </div>
      <template v-else>
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <h5 class="font-size-15 mb-2 mr-2">
            <template v-if="redeemable > 0">Você pode resgatar {{ redeemable }} {{ redeemable == 1 ? "experiência" : "experiências" }}</template>
            <template v-else>Experiências em destaque</template>
          </h5>
          <router-link to="/experiences" class="btn btn-default btn-sm text-uppercase mb-2">Ver experiências</router-link>
        </div>
        <p v-if="highlights.length == 0" class="text-muted mb-0">Nenhuma experiência disponível no momento.</p>
        <div v-else class="row">
          <div v-for="item in highlights" :key="item.id" class="col-12 col-md-4 mb-3">
            <router-link :to="'/experiences/' + item.id" class="d-block home-experience">
              <div class="home-experience-cover bg-light rounded mb-2">
                <img v-if="item.image" :src="item.image" :alt="item.title" />
              </div>
              <div class="font-weight-medium text-truncate">{{ item.title }}</div>
              <div class="font-size-13">{{ formatPoints(item.points) }}</div>
              <small v-if="!item.soldOut && item.missingPoints > 0" class="text-muted">Faltam {{ formatPoints(item.missingPoints) }}</small>
              <small v-else-if="item.canRedeem" class="text-success">Disponível para resgate</small>
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.home-experience {
  color: inherit;
  text-decoration: none;
}

.home-experience-cover {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}

.home-experience-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
